<template>
  <Head>
    <title>
      Политика использования Cookie
      {{ $titleEnd }}
    </title>
    <meta
      name="description"
      content="Ознакомиться с политикой использования Cookie жилого комплекса «Сенсация» в Чите от ГК Основа."
    />
    <meta
      property="og:title"
      :content="'Политика использования Cookie ' + $titleEnd"
    />
    <meta
      property="og:description"
      content="Ознакомиться с политикой использования Cookie жилого комплекса «Сенсация» в Чите от ГК Основа."
    />
  </Head>
  <main class="main">
    <div class="container">
      <Breadcrumbs
        :links="[
          { name: 'Home', text: 'Главная' },
          {
            text: 'Политика использования Cookie',
          },
        ]"
      />
      <h1 class="page-title h2">Политика использования Cookie</h1>
      <p>
        АО «ГК ОСНОВА» (далее — Оператор) обрабатывает данные, указанные в
        настоящем документе (далее — Политика), собранные в процессе
        использования Пользователями текущего Сайта. При нажатии кнопки
        «Принять» в окне-уведомлении об обработке Cookie, Вы даете свое согласие
        на обработку Ваших Cookie. Вы также можете отказаться от обработки
        Cookie в соответствии с пунктом 5 настоящей Политики.
      </p>
      <p>
        <b>1. Что такое файлы Cookie?</b><br />
        <b>Файлы cookie</b> — это небольшой фрагмент данных, который Сайт
        запрашивает у браузера, используемого на Вашем компьютере или мобильном
        устройстве. Файлы cookie содержат информацию о Ваших действиях на Сайте,
        а также могут содержать сведения об оборудовании, дату и время
        сессии.<br />
        <b>Сайт</b> — это совокупность текстов, графических элементов, дизайна,
        изображений, программного кода, и иных результатов интеллектуальной
        деятельности, содержащихся в информационно-телекоммуникационной сети
        «Интернет» под доменным именем «zk-sensation.ru», а также его
        поддоменов.<br />
        <b>Пользователь</b> – физическое лицо, намеревающееся принять Политику
        использования Cookies или принявшее его, а также использующее Сайт
        посредством информационно-телекоммуникационной сети Интернет.
      </p>

      <p>
        <b>2. Как мы используем Ваши Cookie?</b><br />
        Файлы cookie используются Оператором в целях улучшения и обеспечения
        нормальной работоспособности Сайта, а также в целях совершенствования
        продуктов и услуг, предоставляемых Оператором.
      </p>

      <p>
        <b>3. Какие виды Cookie мы используем?</b><br />
        <b>Сессионные.</b> Существуют только во временной памяти в течение
        времени, когда пользователь находится на странице Сайта. Браузеры обычно
        удаляют сессионные файлы cookie после того, как пользователь закрывает
        окно Сайта. Сессионные файлы cookis позволяют Сайту помнить информацию о
        выборе пользователя на предыдущей странице Сайта, чтобы избежать
        необходимости повторного ввода информации.<br />
        <b>Постоянные.</b>
        Файлы cookie, которые хранятся на Вашем устройстве и не удаляются при
        закрытии браузера. Постоянные файлы cookie могут сохранять
        пользовательские настройки для Сайта, позволяя использовать эти
        предпочтения в будущих сеансах использования Сайта. Такие файлы cookie
        позволяют идентифицировать Вас как уникального пользователя Сайта, и при
        возвращении на Сайт помогают вспомнить информацию о Вас и ранее
        совершенных Вами действиях.<br />
        <b>Обязательные.</b> Минимальный набор файлов cookie, использование
        которых необходимо для обеспечения правильной и бесперебойной работы
        Сайта.<br />
        <b>Аналитические / маркетинговые.</b> Эти файлы cookie помогают понять,
        как Вы взаимодействуете с Сайтом, предоставляя информацию о тех
        страницах, которые Вы посетили и количестве времени, которое Вы провели
        на Сайте. Так же эти файлы используются для улучшения функционала Сайта.
        Файлы cookie, относящиеся к аналитике, помогают измерять эффективность
        рекламных кампаний и оптимизировать содержание Сайтов для тех, кого
        заинтересовала реклама владельца Сайта или его партнеров.
      </p>

      <p>
        <b>4. Как мы обрабатываем Ваши Cookie?</b><br />
        На Сайте происходит сбор и обработка обезличенных данных с
        использованием метрических программ и систем аналитики, таких как
        «Яндекс.Метрика». Эта услуга предоставляется компанией ООО «ЯНДЕКС» (ИНН
        7736207543). Дополнительную информацию о сервисе «Яндекс.Метрика» и
        политике конфиденциальности ООО «ЯНДЕКС» можно найти по адресу:
        <a href="https://yandex.ru/legal/confidential/" target="_blank"
          >https://yandex.ru/legal/confidential/</a
        >
        и
        <a href="https://yandex.ru/legal/metrica_termsofuse/" target="_blank"
          >https://yandex.ru/legal/metrica_termsofuse/</a
        >.
      </p>

      <p>
        <b>5. Управление файлами Cookie</b><br />
        Вы в любой момент можете принять решение об отказе предоставления и
        использования файлов cookie или удалить уже сохраненные cookie в
        настройках Вашего браузера. При этом Вы можете просматривать текст на
        Сайте, однако возможности индивидуальной настройки отображения,
        некоторые функции, сервисы, инструменты и возможности Сайта могут быть
        недоступны.<br />
        Если Вы решили отказаться от обработки файлов cookie, то Сайт будет
        использовать только обязательные cookie, необходимые для
        функционирования Сайта.
      </p>

      <p>
        <b>6. Как с нами связаться?</b><br />
        Настоящая Политика размещена на Сайте по адресу:
        https://zk-sensation.ru/cookie-policy и действует бессрочно до ее замены
        новой Политикой. В случае возникновения вопросов, связанных с обработкой
        Ваших персональных данных или реализации Ваших прав как субъекта
        персональных данных, пожалуйста, свяжитесь с нами, используя один из
        способов, указанных на странице <a href="/#contacts">«Контакты»</a>.
      </p>
    </div>
  </main>
</template>
<script>
import Breadcrumbs from "@/components/UI/Breadcrumbs.vue";
import { Head } from "@vueuse/head";
export default {
  components: {
    Head,
    Breadcrumbs,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.page-title.h2 {
  @media (max-width: 575px) {
    font-size: 38px;
  }
}
</style>
